import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import fetch from 'isomorphic-fetch';

import { CONFIG } from 'constants/index';

const CAN_USE_DOM = typeof window !== 'undefined';

const api = createApi({
  reducerPath: 'api',
  tagTypes: ['USER_EVENT', 'LOGS'],
  baseQuery: fetchBaseQuery({ baseUrl: CAN_USE_DOM ? `${window.location.origin}/api` : CONFIG.api, fetchFn: fetch }),
  extractRehydrationInfo(action) {
    if (action.type === 'HYDRATE') {
      return action.payload;
    }
  },
  endpoints: () => ({}),
});

export default api;
